import React from "react";
// Contained button

// Mui
import LoadingButton from "@mui/lab/LoadingButton";
import CircularProgress from "@mui/material/CircularProgress";
import { SxProps, Theme } from "@mui/material/styles";
import { ButtonPropsVariantOverrides } from "@mui/material";

// Types
interface ContainedButtonProps {
  label: string;
  className?: string;
  onClick?: () => void;
  color?: string;
  bgColor?: string;
  borderColor?: string;
  hoverBgColor?: string;
  hoverBorderColor?: string;
  hoverColor?: string;
  fontWeight?: number;
  sx?: SxProps<Theme>;
  loading?: boolean;
  disabled?: boolean;
  loaderColor?: string;
  variant?: "contained" | "text" | "outlined";
}

const ContainedButton: React.FC<ContainedButtonProps> = ({
  label,
  className,
  onClick,
  color,
  bgColor = "#1064ED", // {"linear-gradient(180deg, #1976d2 0%, #0396FF 100%)"}
  borderColor,
  hoverBgColor = "#1064ED", // "linear-gradient(180deg, #75D3FB 0%, #28A6FF 100%""
  hoverBorderColor,
  hoverColor,
  fontWeight,
  sx,
  loading,
  disabled,
  loaderColor,
  variant = "contained",
}) => {
  return (
    <LoadingButton
      variant={variant}
      loading={loading}
      className={className}
      onClick={onClick}
      loadingIndicator={
        <CircularProgress
          size={20}
          style={{ color: loaderColor || "#ffffff" }}
        />
      }
      sx={{
        padding: "8px 15px",
        fontFamily: "Figtree",
        fontSize: "13px",
        fontWeight: fontWeight || 500,
        lineHeight: "15px",
        letterSpacing: "0.32px",
        borderRadius: "8px",
        color: disabled ? "#666666" : color,
        background: disabled ? "#cccccc" : bgColor,
        textTransform: "none",
        borderColor: disabled ? "#999999" : borderColor,
        "&:hover": {
          background: hoverBgColor,
          borderColor: hoverBorderColor,
          color: hoverColor,
        },
        ...sx,
      }}
      disabled={disabled}
    >
      {label}
    </LoadingButton>
  );
};

export default ContainedButton;
